import Vue from 'vue';
import Router from 'vue-router';
import Axios from 'axios';
import config from '../../config/prod.env';

// import finvasia from '@/components/website/index'

const finvasia = () => import('@/components/website/')
const referal_link = () => import('@/components/website/users/referal_link')
const pricing = () => import('@/components/website/pricing/pricing')
const announcements = () => import('@/components/website/announcements/announcements')
const announcement = () => import('@/components/website/announcements/announcement')

const home = () => import('@/components/website/home/home')
const about_us = () => import('@/components/website/shared/about_us')
const support = () => import('@/components/website/shared/support')
const accountopening = () => import('@/components/website/shared/account_opening')
const faq = () => import('@/components/website/shared/faq')
const question = () => import('@/components/website/shared/question')
//contact
const contact_us = () => import('@/components/website/contact/contact_us')

// products
const trading = () => import('@/components/website/products/trading')
const nri = () => import('@/components/website/products/nri')
const loan_against_securities = () => import('@/components/website/products/loan_against_securities')
const mutual_funds = () => import('@/components/website/products/mutual_funds')
const fpi_services = () => import('@/components/website/products/fpi_services')
//const clearing_services_fpi = () => import('@/components/website/products/clearing_services_fpi')
const clearing_services = () => import('@/components/website/products/clearing_services')

//trading
// const scalpert = () => import('@/components/website/trading/scalpert')
const shoonya = () => import('@/components/website/trading/shoonya')
// const nest = () => import('@/components/website/trading/nest')
// const fox_trader = () => import('@/components/website/trading/fox_trader')
// const tradetron = () => import('@/components/website/trading/tradetron')
const hft_algo = () => import('@/components/website/trading/hft_algo')
// const api = () => import('@/components/website/trading/api')
const shoonya_api = () => import('@/components/website/trading/shoonya_api')
const landing_page_api = () => import('@/components/website/trading/landing_page_api')
const api_documentation = () => import('@/components/website/trading/api_documentation')
const institutional_order_book = () => import('@/components/website/trading/institutional_order_book')
const algo_ji = () => import('@/components/website/trading/algo_ji')

const fundtransfer = () => import('@/components/website/shared/fundtransfer')
const download = () => import('@/components/website/shared/download')
const hni = () => import('@/components/website/shared/hni')
// const corporate_lending = () => import('@/components/website/shared/corporate_lending')
//const nse = () => import('@/components/website/shared/nse')

const privacy_policy = () => import('@/components/website/shared/privacy_policy')
const api_terms_of_use = () => import('@/components/website/shared/api_terms_of_use')
const terms_conditions = () => import('@/components/website/shared/terms_conditions')

const policies_and_procedures = () => import('@/components/website/shared/policies_and_procedures')
const trading_view = () => import('@/components/website/shared/policies_and_procedures/trading_view')
//const prop = () => import('@/components/website/shared/prop')

const conflict_of_interst = () => import('@/components/website/shared/conflict_of_interst')

const calculator = () => import('@/components/website/calculator/calculator')
const brokerage = () => import('@/components/website/calculator/brokerage-comparison')
const blog = () => import('@/components/website/blog/blog')
const faq_categories = () => import('@/components/website/faq/categories')
const faq_details = () => import('@/components/website/faq/details')
const faq_articels = () => import('@/components/website/faq/articels')
const retail_investors  = () => import('@/components/website/shared/retail_investors')
// const algo_store  = () => import('@/components/website/algo-store/trading-partners')

const gsapanimation = () => import('@/components/website/trading/shoonya-test')




//policies and procedures
const internal_control_policy_sorm = () => import('@/components/website/shared/policies_and_procedures/internal_control_policy_sorm')
const change_in_currency_derivates = () => import('@/components/website/shared/policies_and_procedures/change_in_currency_derivates')
const how_to_esign = () => import('@/components/website/shared/policies_and_procedures/how_to_esign')
const internal_control_procedures = () => import('@/components/website/shared/policies_and_procedures/internal_control_procedures')
const policy_for_limit_setting = () => import('@/components/website/shared/policies_and_procedures/policy_for_limit_setting')
const policy_regarding_inactive_account = () => import('@/components/website/shared/policies_and_procedures/policy_regarding_inactive_account')
const rms_policy = () => import('@/components/website/shared/policies_and_procedures/rms_policy')
// const risk_disclosure = () => import('@/components/website/shared/policies_and_procedures/rms_policy')
// const surveillance_policy = () => import('@/components/website/shared/policies_and_procedures/surveillance_policy')
const internal_control_margin_procedures = () => import('@/components/website/shared/policies_and_procedures/internal_control_margin_procedures')
const refer_friends = () => import('@/components/website/refer-friends/refer_friends')

//annexure table
const complaints = () => import('@/components/website/complaints/complaint')

const notFound = () => import('@/components/website/shared/notFound')

const ikfTrading = () => import('@/components/website/ikf-trading/ikf-trading.vue')

//kra-status

const kraStatus = () => import('@/components/website/kra-status/kra_status.vue')
Vue.use(Router);

const getFaqSlugs = async(onlyCatSlug)=>{
	try {
		let slugs = [];
		const res = await Axios.post(config.LOCAL_FACADE_SERVER_FULL_ADDRESS.replace(/"/g, '').concat("/api/blog/categories"));
		if(onlyCatSlug){
			slugs = Object.keys(res.data.data.dataArr).map((cat)=>{
				return {category: cat }
			})
		} else {
			slugs = res.data.data.searchArr.map(({catSlug, articleSlug})=>{
				return {category: catSlug,article:articleSlug}
			})
		}
		return slugs;
	} catch (error) {
		console.log("error",error )
		return []
	}
}

export const route = [
	{
	  path: '/',
	  name: 'website.home',
	  component: home,
	  meta: {
		permission: '' 
	  }
	},
	{
		path: '/ai-stock-trading',
		name: 'ikfTrading',
		component: ikfTrading,
		meta: {
			permission: '' 
		}
	},
	{
		path: '/kra-status',
		name: 'verify-kra',
		component: kraStatus,
		meta: {
		  permission: '' 
		}
	},
	{
	  path: '/referral-link',
	  name: 'website.referal_link',
	  component: referal_link,
	  meta: {
		permission: '' 
	  }
	},
	{
	  path: '/about',
	  name: 'website.about_us',
	  component: about_us,
	  meta: {
		permission: '' 
	  }
	},
	{
	  path: '/retail-investors',
	  name: 'website.retail_investors',
	  component: retail_investors,
	  meta: {
		permission: '' 
	  }
	},
	{
	  path: '/contact-us',
	  name: 'website.contact_us',
	  component: contact_us,
	  meta: {
		permission: '' 
	  }
	},
	{
	  path: '/support',
	  name: 'website.support',
	  component: support,
	  meta: {
		permission: '' 
	  }
	},
	{
	  path: '/trading',
	  name: 'website.trading',
	  component: trading,
	  meta: {
		permission: '' 
	  }
	},
	{
	  path: '/nri',
	  name: 'website.nri',
	  component: nri,
	  meta: {
	    permission: '' 
	  }
	},
	{
	  path: '/loan-against-securities',
	  name: 'website.loan_against_securities',
	  component: loan_against_securities,
	  meta: {
		permission: '' 
	  }
	},
	{
	  path: '/mutual-funds',
	  name: 'website.mutual_funds',
	  component: mutual_funds,
	  meta: {
		permission: '' 
	  }
	},
	{
	  path: '/fpi',
	  name: 'website.fpi_services',
	  component: fpi_services,
	  meta: {
		permission: '' 
	  }
	}, 
	{
	  path: '/algo-store',
	  name: 'algo-store.algo_store',
	  redirect: '/',
	  meta: {
		permission: '' 
	  }
	}, 
	// {
	//   path: '/trading-partners',
	//   name: 'algo-store.algo_store',
	//   component: algo_store,
	//   meta: {
	//     permission: '' 
	//   }
	// }, 
	{
	  path: '/clearing-services',
	  name: 'website.clearing_services',
	  component: clearing_services,
	  meta: {
		permission: '' 
	  }
	},	  
	// {
	//   path: '/scalpert',
	//   name: 'website.scalpert',
	//   component: scalpert,
	//   meta: {
	//     permission: '' 
	//   }
	// },	  
	{
	  path: '/shoonya-trading-platform',
	  name: 'website.shoonya_trading',
	  component: shoonya,
	  meta: {
		permission: '' 
	  }
	},
	{
	  path: '/shoonya',
	  name: 'website.shoonya',
	  component: shoonya,
	  meta: {
		permission: '' 
	  }
	},
	// {
	//   path: '/nest',
	//   name: 'website.nest',
	//   component: nest,
	//   meta: {
	// 	permission: '' 
	//   }
	// },	
	// {
	//   path: '/foxtrader',
	//   name: 'website.fox_trader',
	//   component: fox_trader,
	//   meta: {
	// 	permission: '' 
	//   }
	// },		
	// {
	//   path: '/tradetron',
	//   name: 'website.tradetron',
	//   component: tradetron,
	//   meta: {
	// 	permission: '' 
	//   }
	// },              
	{
	  path: '/hft-algo',
	  name: 'website.hft_algo',
	  component: hft_algo,
	  meta: {
		permission: '' 
	  }
	},		
	// {
	//   path: '/api',
	//   name: 'website.api',
	//   component: api,
	//   meta: {
	//     permission: '' 
	//   }
	// },
	{
		path: '/api',
		name: 'shoonya_api.api',
		component: shoonya_api,
		meta: {
		  permission: '' 
		}
	  },		
	  {
		path: '/landing-page-api',
		name: 'website.landing_page_api',
		component: landing_page_api,
	  meta: {
		permission: '' 
	  }
	},	
	{
	  path: '/api-documentation',
	  name: 'website.api_documentation',
	  component: api_documentation,
	  meta: {
		permission: '' 
	  }
	},
	{
	  path: '/fund-transfer',
	  name: 'website.fundtransfer',
	  component: fundtransfer,
	  meta: {
		permission: '' 
	  }
	},
	{
	  path: '/download',
	  name: 'website.download',
	  component: download,
	  meta: {
		permission: '' 
	  }
	},
	{
	  path: '/hni',
	  name: 'website.hni',
	  component: hni,
	  meta: {
		permission: '' 
	  }
	},
	{
	  path: '/pricing',
	  name: 'website.pricing',
	  component: pricing,
	  meta: {
		permission: '' 
	  }
	},
	{
	  path: '/news',
	  name: 'website.announcements',
	  component: announcements,
	  meta: {
		permission: '' 
	  }
	},
	{
		path: '/announcements',
		name: 'website.announcement',
		component: announcement,
		meta: {
		  permission: '' 
		}
	  },
	{
	  path: '/account-opening',
	  name: 'website.accountopening',
	  component: accountopening,
	  meta: {
		permission: '' 
	  }
	},
	{
	  path: '/faq',
	  name: 'website.faq',
	  component: accountopening,
	  meta: {
		permission: '' 
	  }
	},
	{
	  path: '/question',
	  name: 'website.question',
	  component: question,
	  meta: {
		permission: '' 
	  }
	},
	// {
	//   path: '/corporate-lending',
	//   name: 'website.corporate_lending',
	//   component: corporate_lending,
	//   meta: {
	//     permission: '' 
	//   }
	// },
	// {
	//   path: '/nse',
	//   name: 'website.nse',
	//   component: nse,
	//   meta: {
	//     permission: '' 
	//   }
	// },
	{
	  path: '/institutional-order-book',
	  name: 'website.institutional_order_book',
	  component: institutional_order_book,
	  meta: {
		permission: '' 
	  }
	},
	{
	  path: '/algo-ji',
	  name: 'website.algo_ji',
	  component: algo_ji,
	  meta: {
		permission: '' 
	  }
	},
	{
	  path: '/privacy-policy',
	  name: 'website.privacy_policy',
	  component: privacy_policy,
	  meta: {
		permission: '' 
	  }
	},
	{
		path: '/api-terms-of-use',
		name: 'website.api_terms_of_use',
		component: api_terms_of_use,
		meta: {
		  permission: '' 
		}
	},
	// {
	//   path: '/rms-policy',
	//   name: 'website.risk_disclosure',
	//   component: risk_disclosure,
	//   meta: {
	//     permission: '' 
	//   }
	// },
	{
	  path: '/conflict-of-interst',
	  name: 'website.conflict_of_interst',
	  component: conflict_of_interst,
	  meta: {
		permission: '' 
	  }
	},
	{
	  path: '/calculators',
	  name: 'website.calculator',
	  component: calculator,
	  meta: {
		permission: '' 
	  }
	},
	// {
	//   path: '/refer-rewards',
	//   name: 'refer-friends.refer_friends',
	//   component: refer_friends,
	//   meta: {
	// 	permission: '' 
	//   }
	// },
	// {
	//   path: '/refer-friends',
	//   name: 'refer-friends.refer_friends',
	//   component: refer_friends,
	//   meta: {
	//     permission: '' 
	//   }
	// },
	{
	  path: '/brokerage-comparison',
	  name: 'website.brokerage',
	  component: brokerage,
	  meta: {
		permission: '' 
	  }
	},
	{
	  path: '/blog',
	  name: 'website.blog',
	  component: blog,
	  meta: {
		permission: '' 
	  }
	},
	{
	  path: '/policies-and-procedures',
	  name: 'website.policies_and_procedures',
	  component: policies_and_procedures,
	  meta: {
		permission: '' 
	  }
	},
	{
		path: '/policies-and-procedures/trading-view',
		name: 'website.policies_and_procedures',
		component: trading_view,
		meta: {
		  permission: '' 
		}
	},
	{
	  path: '/internal-control-policy-sorm',
	  name: 'website.internal_control_policy_sorm',
	  component: internal_control_policy_sorm,
	  meta: {
		permission: '' 
	  }
	},
	{
		path: '/change-in-currency-derivatives',
		name: 'website.change_in_currency_derivates',
		component: change_in_currency_derivates,
		meta: {
		  permission: '' 
		}
	},
	{
		path: '/how-to-esign',
		name: 'website.how_to_esign',
		component: how_to_esign,
		meta: {
		  permission: '' 
		}
	},
	{
	  path: '/internal-control-procedures',
	  name: 'website.internal_control_procedures',
	  component: internal_control_procedures,
	  meta: {
		permission: '' 
	  }
	},
	{
	  path: '/policy-for-limit-setting',
	  name: 'website.policy_for_limit_setting',
	  component: policy_for_limit_setting,
	  meta: {
		permission: '' 
	  }
	},
	{
	  path: '/policy-regarding-inactive-account',
	  name: 'website.policy_regarding_inactive_account',
	  component: policy_regarding_inactive_account,
	  meta: {
		permission: '' 
	  }
	},
	{
	  path: '/rms-policy',
	  name: 'website.rms_policy',
	  component: rms_policy,
	  meta: {
		permission: '' 
	  }
	},
	{
		path: '/terms-and-conditions',
		name: 'website.terms_conditions',
		component: terms_conditions,
		meta: {
		  permission: '' 
		}
	  },
	// {
	//   path: '/surveillance-policy',
	//   name: 'website.surveillance_policy',
	//   component: surveillance_policy,
	//   meta: {
	// 	permission: '' 
	//   }
	// },
	{
	  path: '/internal-control-margin-procedures',
	  name: 'website.internal_control_margin_procedures',
	  component: internal_control_margin_procedures,
	  meta: {
		permission: '' 
	  }
	},
	{
	  path: '/faqs',
	  name: 'website.faq_categories',
	  component: faq_categories,
	  meta: {
		permission: '' 
	  }
	},
	{
	  path: '/faqs/:category',
	  name: 'website.faq_articels',
	  component: faq_articels,
	  meta: {
		permission: '',
		sitemap: { 
			slugs: async () => await getFaqSlugs(true),
		}
	  }
	},
	{
	  path: '/faqs/:category/:article',
	  name: 'website.faq_details',
	  component: faq_details,
	  meta: {
		permission: '' ,
		sitemap: { 
			slugs: async () => await getFaqSlugs(),
		}
	  }
	},
	// {
	//   path: '/complaints',
	//   name: 'users.complaints',
	//   component: complaints,
	//   meta: {
	// 	permission: '' 
	//   }
	// },
	{
		path: '/animationtest',
		name: 'testpage',
		component: gsapanimation,
		meta: {
			permission: '' 
		}
	},
	{
	  path: '*',
	  name: 'notFound',
	  component: notFound,
	  meta: {
		permission: '' 
	  }
	},
	
] 



export default new Router({
	mode: 'history',
  routes: [
    {
      path:'',
      component: finvasia,
      children: route
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js